import images from './images';

const projects = {
  one: {
    href: 'https://cafe-aroma.netlify.app/',
    image: images.aroma,
  },
  two: {
    href: 'https://torettoluxurytuning.netlify.app/',
    image: images.tlt,
  },
  three: {
    href: 'https://moogletasks.netlify.app/',
    image: images.moogleTasks,
  },
  four: {
    href: 'https://youtelly.netlify.app/',
    image: images.youtelly,
  },
};

export default projects;
